import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Combobox, Icon } from "@zillow/constellation-10";
import { IconSearchFilled } from "@zillow/constellation-icons";
const PLACEHOLDER_TEXT = "Enter your home address";
const searchFieldStyles = css.raw({
  '& [data-c11n-component="Combobox.Trigger"]:not(:focus-within)': {
    backgroundColor: "gray.50",
    boxShadowColor: "border.muted",
    _hover: {
      boxShadowColor: "border.action.hero.selected.default"
    }
  }
});
const inputOverrides = css.raw({
  _placeholder: {
    color: "text.subtle"
  }
});
const SearchInputWithButton = ({
  options: _options,
  renderEmptyState: _renderEmptyState,
  ...props
}) => /* @__PURE__ */ jsx(Combobox.Input, { "data-testid": "address-search-input", placeholder: PLACEHOLDER_TEXT, css: inputOverrides, ...props });
const SearchAdornment = () => /* @__PURE__ */ jsx(Combobox.Adornment, { "aria-hidden": "true", children: /* @__PURE__ */ jsx(Icon, { render: /* @__PURE__ */ jsx(IconSearchFilled, {}) }) });
export {
  PLACEHOLDER_TEXT,
  SearchAdornment,
  SearchInputWithButton as default,
  searchFieldStyles
};
